import styles from "./style.module.scss";
import ReviewCounters from "../../ReviewCounters/ReviewCounters";

interface ReviewModalHeaderProps {
  selectedLabel?: string;
  counters?: { total: number; forReview: number };
}
export default function ReviewModalHeader({
  selectedLabel,
  counters,
}: ReviewModalHeaderProps) {
  return (
    <div className={styles.content}>
      <div className={styles.label}>{selectedLabel}</div>
      <ReviewCounters counters={counters} />
    </div>
  );
}
